<template class="">
  <div class="mb-3 mb-md-5 hidenav">
    <div class="d-flex justify-center pt-3 d-md-none">
      <!-- <img src="/home_of_training.svg" alt="Home of Training Logo"  width="98" class="img-fluid mx-auto"> -->
        <img :src="brandLogo" alt="Brand Logo" width="98" class="img-fluid mx-auto">

      </div>
    <base-nav container-classes="d-flex align-items-center flex-grow-1 mt-3 mt-md-4"
      class="navbar-top  navbar-expand" :class="{ 'top-header navbar-dark': type === 'default' }
"
      >

      <!-- <base-button
      size="sm"
      v-if="currentRouteName != 'Dashboard'"
      @click="$router.go(-1)"
      ><i class="fa fa-arrow-left"></i> Back</base-button
    > -->
      <!-- <div class="header-search">
      <input class="search-input form-control" type="text" placeholder="Search Your Course">
      <span class="searchicon-top"><i class="fas fa-search "></i></span>
    </div> -->

      <!-- Navbar links -->
      <ul class="navbar-nav align-items-center ml-md-auto ml-auto">
        <li class="nav-item d-xl-none">
          <!-- Sidenav toggler -->
          <div class="pr-3 sidenav-toggler" :class="{
            active: $sidebar.showSidebar,
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light'
          }" @click="toggleSidebar">
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
        <li class="nav-item d-sm-none">
          <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
            <i class="ni ni-zoom-split-in"></i>
          </a>
        </li>
      </ul>
      <div class="d-flex flex-grow-1 align-items-center">
        <div class="search-bar mr-auto d-flex">
          <span class="back-btn d-none d-md-block" v-if="currentRouteName != 'Dashboard'"
          @click="$router.go(-1)"><img src="/img/svg-icons/back-btn.svg"> </span>
          <!-- <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.0258 13.8475L18.595 17.4159L17.4158 18.595L13.8475 15.0259C12.5198 16.0902 10.8683 16.6691 9.16667 16.6667C5.02667 16.6667 1.66667 13.3067 1.66667 9.16669C1.66667 5.02669 5.02667 1.66669 9.16667 1.66669C13.3067 1.66669 16.6667 5.02669 16.6667 9.16669C16.6691 10.8684 16.0902 12.5198 15.0258 13.8475ZM13.3542 13.2292C14.4115 12.1414 15.0021 10.6837 15 9.16669C15 5.94419 12.3892 3.33335 9.16667 3.33335C5.94417 3.33335 3.33334 5.94419 3.33334 9.16669C3.33334 12.3892 5.94417 15 9.16667 15C10.6836 15.0021 12.1414 14.4116 13.2292 13.3542L13.3542 13.2292Z" fill="#1E1E1E"/>
        </svg> -->
          <!-- <input type="text" class="form-control" placeholder="Search (CTRL + /)"> -->
          <el-autocomplete popper-class="search-autocomplete" v-model="state" class="autocomplete-wrap"
            :fetch-suggestions="querySearchAsync" placeholder="Search" @select="handleSelect">


            <template slot-scope="{ item }">
              <div v-if="item.isGroup && shouldShowGroup(item.label)" class="auto-complete-block mb-4">
                <div class="auto-heading d-flex align-items-center">
                  <h5>{{ item.label }}</h5>
                  <span class="ml-3">{{ item.count }}</span>
                </div>
                <div class="auto-complete-wrap border-bottom">
                  <div v-for="subItem in item.items" :key="subItem.id"
                    class="auto-complete-content d-flex align-items-center mb-4"
                    @click="handleRowClick(subItem, item.label)">
                    <span class="left">
                      <img :alt="''" width="35" height="35" :src="getIconForGroup(item.label)"
                        :class="{ 'rounded-full': item.label === 'Employee' }">
                    </span>
                    <div class="right pl-3">
                      <h4>{{ getItemName(subItem, item.label) }}</h4>
                      <template v-if="item.label === 'Employee' && subItem.address">
                        <span class="text-gray-600">
                          {{ formatAddress(subItem) }}
                        </span>
                      </template>
                      <template v-if="item.label === 'Company' && subItem.address_1">
                        <span class="text-gray-600">
                          {{ formatCompanyAddress(subItem) }}
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-autocomplete>

        </div>
        <!--
    <a class="notification-wrapper nav-link pr-0">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.16665 7.50002C4.16665 5.95292 4.78123 4.46919 5.87519 3.37523C6.96916 2.28127 8.45289 1.66669 9.99998 1.66669C11.5471 1.66669 13.0308 2.28127 14.1248 3.37523C15.2187 4.46919 15.8333 5.95292 15.8333 7.50002V10.6367L17.3517 13.6734C17.4215 13.8131 17.4545 13.9684 17.4475 14.1245C17.4405 14.2807 17.3937 14.4324 17.3115 14.5653C17.2294 14.6982 17.1146 14.8079 16.9781 14.884C16.8416 14.9601 16.6879 15 16.5317 15H13.2283C13.043 15.7152 12.6253 16.3486 12.041 16.8008C11.4567 17.253 10.7388 17.4983 9.99998 17.4983C9.26115 17.4983 8.54324 17.253 7.95893 16.8008C7.37463 16.3486 6.95701 15.7152 6.77165 15H3.46832C3.31205 15 3.15837 14.9601 3.02187 14.884C2.88538 14.8079 2.7706 14.6982 2.68844 14.5653C2.60628 14.4324 2.55946 14.2807 2.55244 14.1245C2.54542 13.9684 2.57842 13.8131 2.64832 13.6734L4.16665 10.6367V7.50002ZM8.55665 15C8.70294 15.2534 8.91333 15.4637 9.16669 15.61C9.42004 15.7563 9.70744 15.8333 9.99998 15.8333C10.2925 15.8333 10.5799 15.7563 10.8333 15.61C11.0866 15.4637 11.297 15.2534 11.4433 15H8.55665ZM9.99998 3.33335C8.89491 3.33335 7.83511 3.77234 7.0537 4.55374C6.2723 5.33514 5.83332 6.39495 5.83332 7.50002V10.6367C5.8333 10.8953 5.7731 11.1504 5.65748 11.3817L4.68248 13.3334H15.3183L14.3433 11.3817C14.2274 11.1504 14.1669 10.8954 14.1666 10.6367V7.50002C14.1666 6.39495 13.7277 5.33514 12.9463 4.55374C12.1649 3.77234 11.1051 3.33335 9.99998 3.33335Z" fill="#0D0D0D"/>
      </svg>

    <div class="notification-badge">4</div>
    </a> -->
    <span class="back-btn d-block d-md-none ml-3" style="margin-top:2px" v-if="currentRouteName != 'Dashboard'"
    @click="$router.go(-1)"><img src="/img/svg-icons/back-btn.svg"> </span>
        <div class="navbar-nav align-items-center ml-3 ml-md-0 drop-arrow mobilemenuDev" v-if="username != 'Admin'">

          <base-dropdown menu-on-right class="nav-item mr-0 mr-sm-3" tag="div" title-tag="div"
            title-classes="nav-link pr-0 notification-wrapper">
            <div class="nav-link pb-2" @click.prevent slot="title-container">
              <div class="notification-wrapper" >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.16665 7.50002C4.16665 5.95292 4.78123 4.46919 5.87519 3.37523C6.96916 2.28127 8.45289 1.66669 9.99998 1.66669C11.5471 1.66669 13.0308 2.28127 14.1248 3.37523C15.2187 4.46919 15.8333 5.95292 15.8333 7.50002V10.6367L17.3517 13.6734C17.4215 13.8131 17.4545 13.9684 17.4475 14.1245C17.4405 14.2807 17.3937 14.4324 17.3115 14.5653C17.2294 14.6982 17.1146 14.8079 16.9781 14.884C16.8416 14.9601 16.6879 15 16.5317 15H13.2283C13.043 15.7152 12.6253 16.3486 12.041 16.8008C11.4567 17.253 10.7388 17.4983 9.99998 17.4983C9.26115 17.4983 8.54324 17.253 7.95893 16.8008C7.37463 16.3486 6.95701 15.7152 6.77165 15H3.46832C3.31205 15 3.15837 14.9601 3.02187 14.884C2.88538 14.8079 2.7706 14.6982 2.68844 14.5653C2.60628 14.4324 2.55946 14.2807 2.55244 14.1245C2.54542 13.9684 2.57842 13.8131 2.64832 13.6734L4.16665 10.6367V7.50002ZM8.55665 15C8.70294 15.2534 8.91333 15.4637 9.16669 15.61C9.42004 15.7563 9.70744 15.8333 9.99998 15.8333C10.2925 15.8333 10.5799 15.7563 10.8333 15.61C11.0866 15.4637 11.297 15.2534 11.4433 15H8.55665ZM9.99998 3.33335C8.89491 3.33335 7.83511 3.77234 7.0537 4.55374C6.2723 5.33514 5.83332 6.39495 5.83332 7.50002V10.6367C5.8333 10.8953 5.7731 11.1504 5.65748 11.3817L4.68248 13.3334H15.3183L14.3433 11.3817C14.2274 11.1504 14.1669 10.8954 14.1666 10.6367V7.50002C14.1666 6.39495 13.7277 5.33514 12.9463 4.55374C12.1649 3.77234 11.1051 3.33335 9.99998 3.33335Z"
                  fill="#0D0D0D" />
              </svg>

              <div class="notification-badge">{{ unreadNotifications != 0 ? unreadNotifications : 0 }}</div>
            </div>
          </div>


            <template>
              <div class="dropdown-item notfication-wrap">
                <h3>Notification</h3>
                <ul @click="markNotificationAsRead()">
                  <li v-for="notification in notifications" :key="notification.id" @click="markNotificationAsRead()">
                    <a>
                      <!-- <img src="img/theme/avatar.svg" width="40" height="40" /> -->
                      <span>{{ notification.notification.message }}</span>
                    </a>
                  </li>
                </ul>
                <span class="d-block text-center">
                  <router-link to="/notification" class="text-primary">

                    View All
                  </router-link>
                </span>
              </div>
            </template>
          </base-dropdown>
        </div>
        <ul class="navbar-nav align-items-center ml-md-0 mobilemenuDev drop-arrow">
          <base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
            <a href="#" class="nav-link pr-0 pb-2" @click.prevent slot="title-container">
              <div class="media align-items-center">
                <!-- <span class="avatar userprofile bg-transparent p-0 shadow-none position-relative">
                <img alt="Image placeholder" src="img/theme/avatar.svg" />
                <span class="status-icon"></span>
              </span> -->
                <div
                  class="media-body d-none d-lg-block mr-3 username-head"
                  v-intro="'Here you can update your profile information.'"
                  v-intro-step="5"
                  v-intro-if="username === 'employee'"
                >
                  <h3 class="mb-0">{{ name }} <i class="fas fa-chevron-down text-sm"></i></h3>
                  <template v-if="!isSafeDig">
                    <span>{{ companyNameDisplay != "" ? companyNameDisplay : username }}</span> <br>
                  </template>
                </div>



              </div>
            </a>

            <template>
              <!-- <div class="dropdown-header noti-title">
              <div class="username-dropdown">
                <h6 class="text-overflow m-0">Welcome!</h6>
                <span>{{ name }}</span>
              </div>
            </div> -->

              <a v-on:click="account()" class="dropdown-item">
                <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.5 11.25C9.4665 11.25 10.25 10.4665 10.25 9.5C10.25 8.5335 9.4665 7.75 8.5 7.75C7.5335 7.75 6.75 8.5335 6.75 9.5C6.75 10.4665 7.5335 11.25 8.5 11.25Z"
                    stroke="#1E1E1E" />
                  <path
                    d="M2.72433 4.14502L3.05245 3.57627C2.92363 3.50195 2.77338 3.4736 2.62633 3.49585C2.47927 3.51811 2.34414 3.58966 2.24308 3.69877L2.72433 4.14502ZM0.975204 7.17602L0.347829 6.98177C0.303941 7.12391 0.309651 7.27675 0.364022 7.41522C0.418394 7.55369 0.518201 7.66958 0.647079 7.74389L0.975204 7.17602ZM0.973454 11.8231L0.645329 11.2544C0.516424 11.3289 0.416673 11.445 0.362453 11.5836C0.308234 11.7223 0.302768 11.8752 0.346954 12.0174L0.973454 11.8231ZM2.72345 14.8541L2.2422 15.3004C2.34327 15.4095 2.4784 15.481 2.62545 15.5033C2.7725 15.5256 2.92275 15.4972 3.05158 15.4229L2.72345 14.8541ZM6.74845 17.1773H6.0922C6.0922 17.4835 6.30483 17.7486 6.6032 17.8169L6.74845 17.1773ZM10.2493 17.179L10.3955 17.8195C10.5405 17.7864 10.67 17.705 10.7627 17.5886C10.8554 17.4722 10.9057 17.3278 10.9056 17.179H10.2493ZM14.2752 14.855L13.9471 15.4238C14.0759 15.4981 14.2262 15.5264 14.3732 15.5042C14.5203 15.4819 14.6554 15.4104 14.7565 15.3013L14.2752 14.855ZM16.0235 11.8223L16.6508 12.0165C16.6947 11.8744 16.689 11.7215 16.6346 11.5831C16.5803 11.4446 16.4805 11.3287 16.3516 11.2544L16.0235 11.8223ZM16.0252 7.17514L16.3533 7.74389C16.4822 7.66941 16.582 7.55332 16.6362 7.41467C16.6904 7.27602 16.6959 7.12306 16.6517 6.98089L16.0252 7.17514ZM14.2752 4.14327L14.7565 3.69789C14.6554 3.58878 14.5203 3.51723 14.3732 3.49498C14.2262 3.47272 14.0759 3.50108 13.9471 3.57539L14.2752 4.14327ZM10.2502 1.82189H10.9065C10.9064 1.67327 10.8559 1.52905 10.7633 1.41286C10.6706 1.29666 10.5412 1.21536 10.3963 1.18227L10.2502 1.82189ZM6.7502 1.82014L6.60408 1.17964C6.45904 1.21277 6.32956 1.2942 6.23687 1.41057C6.14418 1.52695 6.09379 1.67137 6.09395 1.82014H6.7502ZM1.60258 7.37027C1.92105 6.33507 2.46865 5.38492 3.2047 4.59039L2.2422 3.69789C1.3724 4.63674 0.725225 5.75944 0.348704 6.98264L1.60258 7.37027ZM2.24833 13.1094C1.97821 12.6421 1.76104 12.1461 1.60083 11.6306L0.347829 12.0183C0.536692 12.6273 0.792901 13.2134 1.1117 13.7656L2.24833 13.1094ZM3.20558 14.4096C2.83916 14.0132 2.51809 13.577 2.24833 13.1094L1.1117 13.7656C1.43027 14.318 1.80945 14.8321 2.2422 15.3004L3.20558 14.4096ZM10.1041 16.5403C9.04826 16.7806 7.95188 16.78 6.89633 16.5385L6.60408 17.8178C7.85192 18.1034 9.14809 18.1043 10.3963 17.8204L10.1041 16.5403ZM15.3978 11.6298C15.0794 12.665 14.5318 13.6151 13.7957 14.4096L14.7582 15.3021C15.628 14.3633 16.2752 13.2406 16.6517 12.0174L15.3978 11.6298ZM14.7521 5.89064C15.0268 6.37073 15.2427 6.86364 15.3996 7.36939L16.6526 6.98177C16.4637 6.37272 16.2075 5.78664 15.8887 5.23439L14.7521 5.89064ZM13.794 4.59039C14.1527 4.97802 14.4747 5.41289 14.7512 5.89064L15.8887 5.23439C15.5699 4.68204 15.1895 4.1661 14.7565 3.69789L13.794 4.59039ZM6.89545 2.45977C7.95127 2.21947 9.04765 2.22007 10.1032 2.46152L10.3963 1.18227C9.14849 0.896595 7.85144 0.895698 6.6032 1.17964L6.89545 2.45977ZM7.40558 3.43802V1.81927H6.09308V3.43802H7.40558ZM4.45333 4.38477L3.05245 3.57627L2.3962 4.71289L3.7962 5.52139L4.45333 4.38477ZM2.04708 10.4476L0.646204 11.2561L1.30245 12.3928L2.70333 11.5843L2.04708 10.4476ZM2.70333 7.41577L1.30333 6.60814L0.647079 7.74564L2.04708 8.55327L2.70333 7.41577ZM7.40645 17.1781V15.562H6.09395V17.1781H7.40645ZM3.79708 13.4786L2.3962 14.2871L3.05245 15.4246L4.45245 14.6153L3.79708 13.4786ZM14.6042 14.2871L13.2033 13.4786L12.5471 14.6153L13.9471 15.4238L14.6042 14.2871ZM10.9065 17.1799V15.562H9.59395V17.1808L10.9065 17.1799ZM15.698 6.60727L14.2971 7.41577L14.9533 8.55327L16.3533 7.74389L15.698 6.60727ZM16.3525 11.2553L14.9533 10.4468L14.2971 11.5843L15.6971 12.3919L16.3525 11.2553ZM10.9065 3.43802V1.82189H9.59395V3.43802H10.9065ZM13.948 3.57627L12.5471 4.38477L13.2033 5.52227L14.6042 4.71289L13.948 3.57627ZM9.59395 3.43802C9.59395 5.29039 11.5995 6.44889 13.2033 5.52227L12.5471 4.38477C12.3808 4.48074 12.1923 4.53128 12.0003 4.5313C11.8084 4.53132 11.6198 4.48082 11.4535 4.38488C11.2873 4.28894 11.1492 4.15094 11.0532 3.98473C10.9571 3.81852 10.9065 3.62997 10.9065 3.43802H9.59395ZM14.2971 7.41577C12.6932 8.34239 12.6932 10.6576 14.2971 11.5843L14.9533 10.4468C14.7871 10.3508 14.649 10.2127 14.553 10.0464C14.457 9.88017 14.4065 9.69156 14.4065 9.49958C14.4065 9.3076 14.457 9.11899 14.553 8.95273C14.649 8.78646 14.7871 8.64839 14.9533 8.55239L14.2971 7.41577ZM13.2033 13.4786C11.5995 12.552 9.59395 13.7096 9.59395 15.562H10.9065C10.9065 15.3701 10.9571 15.1815 11.0532 15.0153C11.1492 14.8491 11.2873 14.7111 11.4535 14.6152C11.6198 14.5192 11.8084 14.4687 12.0003 14.4687C12.1923 14.4688 12.3808 14.5193 12.5471 14.6153L13.2033 13.4786ZM7.40645 15.562C7.40645 13.7096 5.40095 12.552 3.79708 13.4786L4.45245 14.6153C4.61869 14.5193 4.80813 14.4688 5.00009 14.4687C5.19204 14.4687 5.38062 14.5192 5.54688 14.6152C5.71314 14.7111 5.85121 14.8491 5.94725 15.0153C6.04327 15.1815 6.09387 15.3701 6.09395 15.562H7.40645ZM2.70333 11.5843C4.3072 10.6576 4.3072 8.34239 2.70333 7.41577L2.04708 8.55327C2.21334 8.64927 2.3514 8.78734 2.44739 8.9536C2.54337 9.11987 2.59391 9.30847 2.59391 9.50045C2.59391 9.69244 2.54337 9.88104 2.44739 10.0473C2.3514 10.2136 2.21334 10.3516 2.04708 10.4476L2.70333 11.5843ZM6.09395 3.43802C6.09387 3.62997 6.04327 3.81852 5.94725 3.98473C5.85121 4.15094 5.71314 4.28894 5.54688 4.38488C5.38062 4.48082 5.19204 4.53132 5.00009 4.5313C4.80813 4.53128 4.61957 4.48074 4.45333 4.38477L3.79708 5.52227C5.40095 6.44802 7.40645 5.29039 7.40645 3.43802H6.09395Z"
                    fill="#1E1E1E" />
                </svg>

                <span name="My Profile">Profile Settings</span>
              </a>
              <div class="dropdown-divider"></div>
              <a v-on:click="logout()" class="dropdown-item">
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.9375 19.6875H11.8125C12.1606 19.6875 12.4944 19.5492 12.7406 19.3031C12.9867 19.0569 13.125 18.7231 13.125 18.375V16.4062H11.8125V18.375H3.9375V2.625H11.8125V4.59375H13.125V2.625C13.125 2.2769 12.9867 1.94306 12.7406 1.69692C12.4944 1.45078 12.1606 1.3125 11.8125 1.3125H3.9375C3.5894 1.3125 3.25556 1.45078 3.00942 1.69692C2.76328 1.94306 2.625 2.2769 2.625 2.625V18.375C2.625 18.7231 2.76328 19.0569 3.00942 19.3031C3.25556 19.5492 3.5894 19.6875 3.9375 19.6875Z"
                    fill="#1E1E1E" />
                  <path
                    d="M13.5096 13.5096L15.8629 11.1562H6.5625V9.84375H15.8629L13.5096 7.49044L14.4375 6.5625L18.375 10.5L14.4375 14.4375L13.5096 13.5096Z"
                    fill="#1E1E1E" />
                </svg>
                <span name="Logout">Logout</span>
              </a>
            </template>
          </base-dropdown>
        </ul>
      </div>
    </base-nav>
  </div>
</template>
<script>
import { BaseNav } from "@/components";
import { Autocomplete } from "element-ui";
import { brandContext } from "@/brand/brandContext"; // ✅ add this

export default {
  components: {
    BaseNav,
    [Autocomplete.name]: Autocomplete,
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)"
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    currentRouteName() {
      return this.$route.name;
    },
     isBrandActive() {
    const b = brandContext.state || {};
    const hasIdentity = !!(b.slug || b.company_name || b.id);
    const enabled = b.is_active === true || b.is_active === 1 || b.enabled === true;
    const hasBranding = !!(b.logo_url || b.logo_path || b.sidebar_logo_url || b.brand_color);
    return (hasIdentity && enabled) || hasBranding;
  },
  brandLoginPath() {
    const b = brandContext.state || {};
    // explicit fields from your brand payload if present
    const direct =
      b.login_route || b.login_path || b.loginUrl || b.login || null;
    if (direct) return direct.startsWith("/") ? direct : `/${direct}`;

    // derive from slug (matches your existing convention like "/boston_login")
    const slug =
      b.slug ||
      localStorage.getItem("brand-slug") ||
      localStorage.getItem("other-company-login"); // last-resort legacy key
    if (slug) {
      if (slug.startsWith("/")) return slug;
      if (slug.endsWith("_login")) return `/${slug}`;
      return `/company/${slug}`;
    }

    // default
    return "/login";
  },
  // ✅ pick best available logo from branding, otherwise fallback to tenant default
  brandLogo() {
    const b = brandContext.state || {};
    const tenantFallback =
      process.env.VUE_APP_COMPANY_NAME_FRONTEND === "projectglad"
        ? "/project_glad_logo.svg"
        : "/home_of_training.svg";
    return (
      b.sidebar_logo_url ||
      b.logo_url ||
      (b.logo_path ? `/${b.logo_path}` : tenantFallback)
    );
  },
  isSafeDig() {
    return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
  }

  },
  data() {
    return {
      name: "Admin",
      link: "",
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      username: "",
      user_id: "",
      links: [],
      searchData: [],
      state: '',
      data: false,
      timeout: null,
      filters: [
        { id: 'people', name: 'People' },
        { id: 'location', name: 'Location' },
        { id: 'course', name: 'Course' },
        { id: 'tutorial', name: 'Tutorial' }
      ],
      activeFilters: ['people', 'location', 'course', 'tutorial'], // All active by default
      notifications: [],
      totalNotifications: 0,
      unreadNotifications: 0,
      companys_id: '',
      companyNameDisplay: ""
    };
  },
  created: function () {
    if (localStorage.getItem("hot-user") === "employee") {
      this.username = "employee";
      this.user_id = localStorage.getItem("hot-user-id");
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.username = "Admin";
      this.companyNameDisplay = "Super Admin";
      this.user_id = localStorage.getItem("hot-user-id") || "";
    } else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.username = "Admin";
      this.companyNameDisplay = "Sub Admin";
      this.user_id = localStorage.getItem("hot-user-id") || "";
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.username = "company";
      this.user_id = localStorage.getItem("hot-admin-id");
      this.companys_id = localStorage.getItem("hot-user-id");
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.username = "manager";
      this.user_id = localStorage.getItem("hot-user-id");
    }
    this.fetchCompanyName();
    // this.fetchEmpCompanyName();
    this.getNotifications();

  },
  mounted() {
    this.links = this.loadAll();
    if (localStorage.getItem("hot-sidebar") === "admin") {
      this.name = localStorage.getItem("hot-user-full-name");
      this.link = "/account";
    } else if (localStorage.getItem("hot-user") === "employee") {
      this.name = localStorage.getItem("hot-user-name");
      this.link = "/add_employee";
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.name = localStorage.getItem("hot-user-name");
      this.link = "/account";
    }
  },
  methods: {
    fetchCompanyName() {
      if (this.username == "employee" || this.username == "manager") {
        this.fetchEmpCompanyName();
        return;
      }
      // Super/sub-admin have no company row in the navbar; path id must not be empty (avoids GET .../get-company/?... 404).
      if (!this.companys_id) {
        return;
      }
      this.$http.get(`get-company/${this.companys_id}`, {
        params: {
          usertype: this.username,
          user_id: this.user_id
        }
      }).then((res) => {
        this.companyNameDisplay = res.data.name;
      });
    },
    fetchEmpCompanyName() {
      this.$http.get(`get-emp-company`, {
        params: {
          usertype: this.username,
          user_id: this.user_id
        }
      }).then((res) => {
        this.companyNameDisplay = res.data.name;
      });
    },
    markNotificationAsRead() {
      // this.$http.post(`notification/mark-read`,{
      //  user_id : this.user_id,
      //  notification_id : not_id
      // }).then((res)=>{
      //   this.getNotifications();
      // });
      this.$router.push(`/notification`);
    },
    markedNotificationAsRead() {
      this.$http.post(`notification/mark-read`, {
        user_id: this.user_id,
      }).then((res) => {
        this.getNotifications();
      });
    },
    getNotifications() {
      this.$http.get(`notification/user/${this.user_id}`, { params: { all: false } }).then((res) => {
        this.data = true;
        this.notifications = res.data;
        this.totalNotifications = res.data.length;
        this.unreadNotifications = res.data.filter(notification => notification.is_read === 0).length;
      });
    },
    handleRowClick(subItem, label) {
      // Super admin search
      if (localStorage.getItem("hot-user") === "super-admin" || localStorage.getItem("hot-user") === "sub-admin") {
        if (label === "Employee" && subItem.id) {
          // Navigate to the employee page with the ID
          // this.$router.push(`/add_employee?id=${subItem.id}`);
          window.location.href = `/#/add_employee?id=${subItem.id}`;
          window.location.reload(); // This forces a hard reload
        } else if (label === "Company" && subItem.id) {
          // Navigate to the company page (example)
          // this.$router.push(`/edit_company?id=${subItem.id}`);
          window.location.href = `/#/edit_company?id=${subItem.id}`;
          window.location.reload(); // This forces a hard reload

        } else if (label === "Course" && subItem.id) {
          // this.$router.push(`edit_course?id=${subItem.id}`)
          window.location.href = `/#/edit_course?id=${subItem.id}`;
          window.location.reload(); // This forces a hard reload

        } else if (label === "Tutorial" && subItem.id) {
          // this.$router.push(`add_tutorial_video?id=${subItem.id}`)
          window.location.href = `/#/add_tutorial_video?id=${subItem.id}`;
          window.location.reload(); // This forces a hard reload

        }
      }

      else if (localStorage.getItem("hot-user") === "employee") {
        if (label === "Course" && subItem.id) {
          // this.$router.push(`edit_course?id=${subItem.id}`)
          window.location.href = `/#/employee_course`; // Updated to specific course
          window.location.reload(); // This forces a hard reload

        } else if (label === "Tutorial" && subItem.id) {
          // this.$router.push(`tutorial_video`)
          window.location.href = `/#/tutorial_video`;
          window.location.reload();
        } else if (label === "Certificates" && subItem.id) {
          // this.$router.push(`employee_certificates`)
          window.location.href = `/#/employee_certificates`
          window.location.reload();
        }

      }
      else if (localStorage.getItem("hot-user") === "company-admin" || localStorage.getItem("hot-user") === "manager") {
        if (label === "Employee" && subItem.id) {
          // Navigate to the employee page with the ID
          // this.$router.push(`/add_employee?id=${subItem.id}`);
          window.location.href = `/#/add_employee?id=${subItem.id}`;
          window.location.reload();
        } else if (label === "Company" && subItem.id) {
          // Navigate to the company page (example)
          // this.$router.push(`/add_location?id=${subItem.id}`);
          window.location.href = `/#/add_location?id=${subItem.id}`;
          window.location.reload();
        } else if (label === "Course" && subItem.id) {
          // this.$router.push(`edit_course?id=${subItem.id}`)
          // this.$router.push(`/courses`);
          window.location.href = `/#/courses`; // Updated to specific course
          window.location.reload();
        } else if (label === "Tutorial" && subItem.id) {
          // this.$router.push(`tutorial_video`)
          window.location.href = `/#/tutorial_video`;
          window.location.reload();
        }

      }
    },
    account() {
      if (localStorage.getItem("hot-user") === "employee") {
        this.$router.push("/add_employee");
      } else if (localStorage.getItem("hot-user") === "super-admin") {
        this.$router.push("/account");
      } else if (localStorage.getItem("hot-user") === "sub-admin") {
        this.$router.push("/account");
      } else if (localStorage.getItem("hot-user") === "company-admin") {
        this.$router.push("/account");
      } else if (localStorage.getItem("hot-user") === "manager") {
        this.$router.push("/account");
      }
    },
    // logout() {

    //   this.$http
    //     .get("user/logout_time")
    //     .then(resp => {
    //     });

    //   localStorage.removeItem("hot-token");
    //   localStorage.removeItem("hot-email");
    //   localStorage.removeItem("hot_payment_responsible");
    //   localStorage.removeItem("hot-sidebar");
    //   localStorage.removeItem("hot-user-id");
    //   localStorage.removeItem("hot-company-id");
    //   localStorage.removeItem("hot-user");
    //   localStorage.removeItem("all_user_search_data");
    //   localStorage.removeItem("all_company_search_data");
    //   localStorage.removeItem("all_courses_search_data");
    //   localStorage.removeItem("all_certificate_search_data");
    //   localStorage.removeItem("all_tutorial_video_search_data");
    //   localStorage.removeItem("all_certificate_detail_search_data");

    //   delete this.$http.defaults.headers["authorization"];

    //   // Remove the style tag that hides the reCAPTCHA badge
    // document.querySelectorAll('style').forEach(style => {
    //   if (style.innerHTML.includes('.grecaptcha-badge')) {
    //     style.remove();
    //   }
    // });

    //   // this.$router.push("/login");
    //   const redirectKey = localStorage.getItem('other-company-login');
    //   localStorage.removeItem("other-company-login");
    //   if (redirectKey) {
    //     // if you stored e.g. "boston_login", go to "/boston_login"
    //     this.$router.push(`/${redirectKey}`);
    //   } else {
    //     this.$router.push('/login');
    //   }
    // },
      logout() {
    // compute destination BEFORE clearing storage
    const isSafeDig = process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
    if (isSafeDig) {
      // Safe Dig: redirect to /login (same path for both builds)
      this.$http.get("user/logout_time").catch(() => { /* ignore */ });
      this.clearStorageAndRedirect('/login');
      return;
    }
    const legacyRedirectKey = localStorage.getItem("other-company-login");
    const fallbackFromLegacy = legacyRedirectKey ? `/${legacyRedirectKey}` : "/login";
    const destination = this.isBrandActive ? this.brandLoginPath : fallbackFromLegacy;

    // optional: ping server for logout time (as you already do)
    this.$http.get("user/logout_time").catch(() => { /* ignore */ });

    // clear auth/session/local search caches
    localStorage.removeItem("hot-token");
    localStorage.removeItem("hot-email");
    localStorage.removeItem("hot_payment_responsible");
    localStorage.removeItem("hot-sidebar");
    localStorage.removeItem("hot-user-id");
    localStorage.removeItem("hot-company-id");
    localStorage.removeItem("hot-user");
    localStorage.removeItem("all_user_search_data");
    localStorage.removeItem("all_company_search_data");
    localStorage.removeItem("all_courses_search_data");
    localStorage.removeItem("all_certificate_search_data");
    localStorage.removeItem("all_tutorial_video_search_data");
    localStorage.removeItem("all_certificate_detail_search_data");
    // remove legacy brand key AFTER we captured it
    localStorage.removeItem("other-company-login");

    // drop auth header
    delete this.$http.defaults.headers["authorization"];

    // unhide reCAPTCHA if you had hidden it
    document.querySelectorAll("style").forEach((style) => {
      if (style.innerHTML.includes(".grecaptcha-badge")) style.remove();
    });

    // finally redirect
    this.$router.push(destination);
  },
  clearStorageAndRedirect(destination) {
    localStorage.removeItem("hot-token");
    localStorage.removeItem("hot-email");
    localStorage.removeItem("hot_payment_responsible");
    localStorage.removeItem("hot-sidebar");
    localStorage.removeItem("hot-user-id");
    localStorage.removeItem("hot-company-id");
    localStorage.removeItem("hot-user");
    localStorage.removeItem("all_user_search_data");
    localStorage.removeItem("all_company_search_data");
    localStorage.removeItem("all_courses_search_data");
    localStorage.removeItem("all_certificate_search_data");
    localStorage.removeItem("all_tutorial_video_search_data");
    localStorage.removeItem("all_certificate_detail_search_data");
    localStorage.removeItem("other-company-login");
    delete this.$http.defaults.headers["authorization"];
    document.querySelectorAll("style").forEach((style) => {
      if (style.innerHTML && style.innerHTML.includes(".grecaptcha-badge")) style.remove();
    });
    this.$router.push(destination);
  },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    //  querySearch(queryString, cb) {
    //   var links = this.links;
    //   var results = queryString ? links.filter(this.createFilter(queryString)) : links;
    //   // call callback function to return suggestion objects
    //   cb(results);
    // },
    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    loadAll() {
      return [
        { "value": "vue", "link": "https://github.com/vuejs/vue" },
      ];
    },
    handleIconClick(ev) {
      console.log(ev);
    },
    toggleFilter(filterId) {
      const index = this.activeFilters.indexOf(filterId);
      if (index === -1) {
        this.activeFilters.push(filterId);
      } else {
        this.activeFilters.splice(index, 1);
      }
    },
    shouldShowGroup(label) {
      const filterMap = {
        'Employee': 'people',
        'Company': 'location',
        'Course': 'course',
        'Tutorial': 'tutorial'
      };
      return this.activeFilters.includes(filterMap[label]);
    },
    formatAddress(item) {
      const parts = [];
      if (item.address) parts.push(item.address);
      if (item.city) parts.push(item.city);
      if (item.state) parts.push(item.state);
      if (item.zipcode) parts.push(item.zipcode);
      return parts.join(', ');
    },
    formatCompanyAddress(item) {
      const parts = [];
      if (item.address_1) parts.push(item.address_1);
      if (item.city) parts.push(item.city);
      if (item.state) parts.push(item.state);
      return parts.join(', ');
    },
    querySearchAsync(queryString, cb) {

      if (!queryString) {
        cb([]);
        return;
      }

      const userRole = localStorage.getItem("hot-user");
      const userId = localStorage.getItem("hot-user-id");
      const adminId = localStorage.getItem("hot-admin-id");

      let apiEndpoint = "";
      let requestData = { search: queryString };

      if (userRole === "super-admin") {
        apiEndpoint = "/super-global-search";
      } else if (userRole === "sub-admin") {
        apiEndpoint = "/super-global-search";
      } else if (userRole === "employee") {
        apiEndpoint = "/user-global-search";
        requestData.id = userId;
      } else if (userRole === "company-admin" || userRole === "manager") {
        apiEndpoint = "/company-global-search";
        requestData.id = userRole === "company-admin" ? adminId : userId;
        requestData.company_id = userRole === "company-admin" ? userId : adminId;
      }

      if (apiEndpoint) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.$http
            .post(apiEndpoint, requestData)
            .then((response) => {
              const data = response.data;
              this.searchData = this.formatSearchData(userRole, data);
              cb(this.searchData);
            })
            .catch((error) => {
              console.error("Search error:", error);
              cb([]);
            });
        }, 300);
      } else {
        cb([]);
      }
    },
    formatSearchData(role, data) {
      const groupedData = [];

      if (role === "super-admin" || role === "company-admin" || role === "sub-admin" || role === "manager") {
        groupedData.push(
          this.createGroup("Employee", data.users),
          this.createGroup("Company", data.companies),
          this.createGroup("Course", data.courses),
          this.createGroup("Tutorial", data.videos)
        );
      } else if (role === "employee") {
        groupedData.push(
          this.createGroup("Course", data.courses),
          this.createGroup("Tutorial", data.videos)
        );
      }

      return groupedData.filter((group) => group.items.length > 0);
    },
    createGroup(label, items) {
      return {
        isGroup: true,
        label,
        count: items ? items.length : 0,
        items: items || []
      };
    },
    handleSelect(item) {
      console.log("Selected item:", item);
    },
    getIconForGroup(groupLabel) {
      const icons = {
        Employee: 'img/theme/avatar.svg',
        Company: 'img/theme/location_icon.svg',
        Course: 'img/theme/courses-auto.svg',
        Tutorial: 'img/theme/tutorial_icon.svg'
      };
      return icons[groupLabel] || 'img/theme/default_icon.svg';
    },
    getItemName(item, groupLabel) {
      switch (groupLabel) {
        case 'Employee':
          return item.full_name;
        case 'Tutorial':
          return item.video_title;
        case 'Course':
          return item.name;
        case 'Company':
          return item.name;
        default:
          return item.name || 'Unnamed Item';
      }
    }
  }
};
</script>
<style scoped>
.auto-complete-content:hover {
  background-color: #f0f0f0 !important; /* or any color you like */
  cursor: pointer;
  border-radius: 6px;
}


/* .search-bar { */
/* display: flex;
      width: 420px;
      align-items: center;
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 50px;
      padding: 0.1rem 1.2rem;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      margin-right: auto; */
/* } */

.search-bar>>>input {
  display: flex;
  width: 370px;
  align-items: center;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 50px;
  padding: 0.1rem 1.2rem 0.1rem 3rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-right: auto;
  border: none;
  outline: none;
  flex-grow: 1;
  font-size: 1rem;
  background: #fff url(/img/svg-icons/search-icon.svg) no-repeat 15px 9px;
}

@media screen and (max-width:575px) {
  .search-bar>>>input {
    width: 100%;
    /* border: 0;
    padding: 0;
    width: 20px;
    height: 20px;
    box-shadow: none;
    border-radius: 0;
    background: transparent url(/img/svg-icons/search-icon.svg) no-repeat 0 0; */

  }

  .search-bar>>>input::placeholder {
    display: none;
    background: transparent;
    color: transparent;
  }
}

.search-bar input::placeholder {
  font-size: 0.9rem;
  color: #aaa;
}

.search-bar svg {
  width: 1.2rem;
  height: 1.2rem;
  color: #888;
}

@media screen and (max-width: 767px) {
  .navbar-dark .navbar-nav .nav-link {
    padding-left: 0;
    white-space: nowrap;
  }

  .search-bar {
    width: auto;
    border: 0;
    background: transparent;
    box-shadow: none;
    padding-left: 0;
  }

  /* .search-bar input {
    display: none;
  } */
}

.notification-wrapper {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.notification-bell {
  font-size: 1.5rem;
  color: #000;
}

.notification-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  background: #f44336;
  color: #fff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>
